export const isBusinessEmail = /^(?!.+@(gmail|yahoo|outlook|hotmail|msn|live|aol|test)\..+)(.+@.+\..+)$/;
